const homeRuntime=JSON.parse(document.querySelector('#ses-home-runtime').textContent);
const slider=document.querySelector('.compare-box input');
function updateComparison(){
 const box=slider.closest('.compare-box'),value=Number(slider.value);
 box.style.setProperty('--split',value+'%');
 box.querySelector('.compare-label.left').hidden=value<20;
 box.querySelector('.compare-label.right').hidden=value>80;
 slider.setAttribute('aria-valuetext',value===0?'Eén uitbreidingsbatterij':value===100?'Twee uitbreidingsbatterijen':`${value}% van het grotere systeem zichtbaar`);
}
slider.addEventListener('input',updateComparison);
updateComparison();
const dialog=document.querySelector('.video-dialog');
document.querySelectorAll('[data-video]').forEach(b=>b.addEventListener('click',()=>{dialog.querySelector('iframe').src='https://www.youtube-nocookie.com/embed/'+b.dataset.video+'?autoplay=1&rel=0';dialog.showModal();}));
document.querySelector('.close-dialog').addEventListener('click',()=>dialog.close());
dialog.addEventListener('close',()=>dialog.querySelector('iframe').removeAttribute('src'));
dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
document.querySelector('.faq-search').addEventListener('submit',e=>{
 e.preventDefault();const input=document.querySelector('#faq-query'),query=input.value.trim().toLocaleLowerCase('nl');
 if(!query)return;
 const answers=[...document.querySelectorAll('.faq-list details')];const matches=answers.filter(d=>d.textContent.toLocaleLowerCase('nl').includes(query));
 answers.forEach(d=>d.open=matches.includes(d));
 const result=document.querySelector('.search-result');result.replaceChildren();
 document.querySelector('.search-message').textContent=matches.length?`${matches.length} antwoord${matches.length===1?'':'en'} gevonden op deze pagina.`:'Geen antwoord gevonden op deze pagina.';
 if(matches.length){result.hidden=true;matches[0].scrollIntoView({behavior:'smooth',block:'center'});}else{result.hidden=false;const link=document.createElement('a');link.href='https://slimme-energieopslag.nl/pages/faq';link.target='_blank';link.rel='noopener';link.textContent='Bekijk alle veelgestelde vragen of neem contact met ons op.';result.append(link);}
});

const brandToggle=document.querySelector('.brand-toggle');
brandToggle.addEventListener('click',()=>{const paused=document.querySelector('.brand-row').classList.toggle('paused');brandToggle.setAttribute('aria-pressed',String(paused));brandToggle.setAttribute('aria-label',paused?'Merkenbeweging hervatten':'Merkenbeweging pauzeren');brandToggle.textContent=paused?'▶':'Ⅱ';});
const calendarHost=document.querySelector('#showroom-calendar');
let calendarLoading=false;
function loadShowroomCalendar(){
 if(calendarLoading)return;calendarLoading=true;
 window.shopifyDomain=homeRuntime.shop;
 window.Shopify=window.Shopify||{};window.Shopify.shop=window.Shopify.shop||homeRuntime.shop;window.Shopify.locale=window.Shopify.locale||homeRuntime.locale;
 const script=document.createElement('script');
 script.src='https://cdn.shopify.com/extensions/01a13d51-dec8-79e3-b767-6de560b6cc98/digital-appointments-576/assets/embedInit.js';
 script.async=true;
 const unavailable=()=>{calendarHost.querySelector('.booking-loading').textContent='De kalender kan op dit moment niet worden geladen. Probeer de pagina opnieuw te laden.';};
 script.onerror=unavailable;
 script.onload=()=>{
  if(!window.Servicify?.renderCalendar){unavailable();return;}
  window.Servicify.renderCalendar(calendarHost,{eventSlug:'2f2be1fc-6800-4b45-9065-8c21d38ebe73',variantId:homeRuntime.appointmentVariant||'55616908951892',onReady:()=>{calendarHost.querySelector('.booking-loading')?.remove();calendarHost.querySelector('[data-servicify="time-format-24h"]')?.click();formatCalendarDescription();},onError:unavailable}).catch(()=>{});
 };
 if(window.Servicify?.renderCalendar){script.onload();}else{
  const existing=[...document.scripts].find(s=>s.src.includes('digital-appointments-')&&s.src.includes('embedInit.js'));
  if(existing){let attempts=0;const ready=setInterval(()=>{attempts++;if(window.Servicify?.renderCalendar){clearInterval(ready);script.onload();}else if(attempts>=100){clearInterval(ready);document.head.append(script);}},100);}else document.head.append(script);
 }
}
if(new URLSearchParams(location.search).get('afhalen')==='1')loadShowroomCalendar();
const calendarObserver=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){loadShowroomCalendar();calendarObserver.disconnect();}},{rootMargin:'400px'});
calendarObserver.observe(calendarHost);

const bookingModalObserver=new MutationObserver(()=>{
 const open=!!document.querySelector('.servicify-modal-portal [role="dialog"],.ReactModal__Content--after-open');
 const content=document.querySelector('#page-content');
 if(open){if(document.body.getAttribute('aria-hidden')==='true')document.body.removeAttribute('aria-hidden');if(!content.inert){content.inert=true;content.setAttribute('aria-hidden','true');}}
 else if(content.inert){content.inert=false;content.removeAttribute('aria-hidden');}
});
bookingModalObserver.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-hidden']});

const videoCarousel=document.querySelector('#video-carousel');
const videoCards=[...videoCarousel.querySelectorAll('.video-card')];
const videoPrevious=document.querySelector('.video-previous');
const videoNext=document.querySelector('.video-next');
const mobileVideoLayout=matchMedia('(max-width:600px)');
let videoDrag=null,lastVideoDrag=0;
function activeVideoIndex(){return Math.max(0,Math.min(videoCards.length-1,Math.round(videoCarousel.scrollLeft/(videoCards[0].offsetWidth+14))));}
function updateVideoNavigation(){
 const index=activeVideoIndex();
 videoPrevious.disabled=index===0;videoNext.disabled=index===videoCards.length-1;
 document.querySelector('.video-count').textContent=`Video ${index+1} van ${videoCards.length}`;
 document.querySelectorAll('.video-dot').forEach((dot,i)=>dot.classList.toggle('active',i===index));
}
function goToVideo(index){
 const target=videoCards[Math.max(0,Math.min(videoCards.length-1,index))];
 videoCarousel.scrollTo({left:target.offsetLeft-videoCards[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
}
videoPrevious.addEventListener('click',()=>goToVideo(activeVideoIndex()-1));
videoNext.addEventListener('click',()=>goToVideo(activeVideoIndex()+1));
videoCarousel.addEventListener('scroll',updateVideoNavigation,{passive:true});
videoCarousel.addEventListener('keydown',event=>{if(mobileVideoLayout.matches&&(event.key==='ArrowLeft'||event.key==='ArrowRight')){event.preventDefault();goToVideo(activeVideoIndex()+(event.key==='ArrowRight'?1:-1));}});
videoCarousel.addEventListener('pointerdown',event=>{
 if(!mobileVideoLayout.matches||event.pointerType!=='mouse'||event.button!==0)return;
 videoDrag={id:event.pointerId,x:event.clientX,left:videoCarousel.scrollLeft,moved:false};
});
videoCarousel.addEventListener('pointermove',event=>{
 if(!videoDrag||event.pointerId!==videoDrag.id)return;
 const delta=event.clientX-videoDrag.x;
 if(Math.abs(delta)>6){videoDrag.moved=true;videoCarousel.classList.add('dragging');videoCarousel.setPointerCapture(event.pointerId);event.preventDefault();videoCarousel.scrollLeft=videoDrag.left-delta;}
});
function endVideoDrag(){
 if(!videoDrag)return;
 const moved=videoDrag.moved,index=activeVideoIndex();videoDrag=null;videoCarousel.classList.remove('dragging');
 if(moved){lastVideoDrag=Date.now();goToVideo(index);}
}
videoCarousel.addEventListener('pointerup',endVideoDrag);
videoCarousel.addEventListener('pointercancel',endVideoDrag);
videoCarousel.addEventListener('click',event=>{if(Date.now()-lastVideoDrag<350){event.preventDefault();event.stopImmediatePropagation();}},true);
document.querySelectorAll('.video-mobile-play').forEach(button=>button.addEventListener('click',()=>{
 const cover=button.closest('.video-embed'),frame=cover.querySelector('iframe');
 frame.src=frame.src+(frame.src.includes('?')?'&':'?')+'autoplay=1&mute=1';
 cover.classList.add('video-playing');
 frame.inert=false;
}));
function syncVideoPlayers(){videoCards.forEach(card=>{const cover=card.querySelector('.video-embed');cover.querySelector('iframe').inert=mobileVideoLayout.matches&&!cover.classList.contains('video-playing');});}
mobileVideoLayout.addEventListener('change',()=>{videoCarousel.scrollLeft=0;updateVideoNavigation();syncVideoPlayers();});
updateVideoNavigation();
syncVideoPlayers();

function formatCalendarDescription(){
 const description=calendarHost.querySelector('[data-servicify="description"]');
 if(!description||description.childElementCount)return;
 const lines=description.textContent.split(/\n+/).map(line=>line.trim()).filter(Boolean);
 if(lines.length<2)return;
 description.replaceChildren(...lines.map(line=>{const paragraph=document.createElement('p');paragraph.textContent=line;return paragraph;}));
 description.classList.add('calendar-paragraphs');
}
const calendarTextObserver=new MutationObserver(formatCalendarDescription);
calendarTextObserver.observe(calendarHost,{childList:true,subtree:true,characterData:true});
formatCalendarDescription();

const footerDisclosures=[...document.querySelectorAll('.footer-compact .footer-disclosure')];
const wideFooter=matchMedia('(min-width:701px)');
function syncFooterGroups(){footerDisclosures.forEach(group=>{group.open=wideFooter.matches;});}
wideFooter.addEventListener('change',syncFooterGroups);
syncFooterGroups();

const showroomFilm=document.querySelector('.appointment-film iframe[data-showroom-src]');
if(showroomFilm){
 const showroomFilmObserver=new IntersectionObserver(entries=>{
  if(entries.some(entry=>entry.isIntersecting)){
   showroomFilm.src=showroomFilm.dataset.showroomSrc;
   showroomFilmObserver.disconnect();
  }
 },{threshold:0.2});
 showroomFilmObserver.observe(showroomFilm);
}

if(![...document.scripts].some(s=>s.src.includes('dashboard.webwinkelkeur.nl/sidebar.js'))){const reviewsScript=document.createElement('script');reviewsScript.src='https://dashboard.webwinkelkeur.nl/sidebar.js?id=1225666&c=2986664';reviewsScript.async=true;document.head.append(reviewsScript);}
